import React from 'react';
import {UserList} from "components/user/UserList";
import {Provider} from "components/user/UserContext";

export const Users = () => {

    return (
        <Provider>
            <UserList/>
        </Provider>
    );
}
